import React from 'react';
export const CollectionSkeletonRow = () => {
  return <tr data-id="element-136">
      <td className="px-6 py-4" data-id="element-137">
        <div className="flex items-center" data-id="element-138">
          <div className="h-10 w-10 rounded bg-gray-200 animate-pulse mr-3" data-id="element-139"></div>
          <div className="h-4 w-40 bg-gray-200 rounded animate-pulse" data-id="element-140"></div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-141">
        <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" data-id="element-142"></div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-143">
        <div className="h-4 w-8 bg-gray-200 rounded animate-pulse" data-id="element-144"></div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-145">
        <div className="h-6 w-12 bg-gray-200 rounded-full animate-pulse" data-id="element-146"></div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-147">
        <div className="h-5 w-20 bg-gray-200 rounded-full animate-pulse" data-id="element-148"></div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-right" data-id="element-149">
        <div className="flex items-center justify-end space-x-3" data-id="element-150">
          <div className="h-5 w-5 bg-gray-200 rounded animate-pulse" data-id="element-151"></div>
          <div className="h-5 w-5 bg-gray-200 rounded animate-pulse" data-id="element-152"></div>
          <div className="h-5 w-5 bg-gray-200 rounded animate-pulse" data-id="element-153"></div>
        </div>
      </td>
    </tr>;
};